import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState, ListStateItem, ListModuleItem} from '@/store/shared'
import Role from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

interface RoleState extends ListStateItem<Role>{
    editRole:Role;
    permissions:Array<string>
}
class RoleModule extends ListModuleItem<RoleState,any,Role>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editRole:new Role(),
        permissions:new Array<string>()
    }

    actions={
        async getAll(context:ActionContext<RoleState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('/services/app/Role/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Role>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<RoleState,any>,payload:any){
            await $http.post('services/app/Role/Create',payload.data);
        },
        async update(context:ActionContext<RoleState,any>,payload:any){
            await $http.put('services/app/Role/Update',payload.data);
        },
        async delete(context:ActionContext<RoleState,any>,payload:any){
            await $http.delete('services/app/Role/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<RoleState,any>,payload:any){
            let reponse=await $http.get('services/app/Role/Get?Id='+payload.id);
            context.state.editRole = reponse.data.result;
            return reponse.data.result;
        },
        async getAllPermissions(context:ActionContext<RoleState,any>){
            let reponse=await $http.get('services/app/Role/GetAllPermissions');
            context.state.permissions=reponse.data.result.items;
        },
        async setAllPermissions(context:ActionContext<RoleState,any>,payload:any){
            await $http.post('services/app/Role/SetPermissions',payload.data);
        },
    };
    overrideMutations={
        edit(state:RoleState,role:Role){
            state.editRole=role;
        }
    }
}
const roleModule=new RoleModule();
export default roleModule;